module.exports = __webpack_public_path__ + "static/img/UM.447e2bf0.svg";